import { useState } from 'react';
import './App.scss';
import { Header } from './components/layout/Header';
import { Map } from './components/Map/Map';
import { SearchContext } from './context/search.context';
import { CoordinatesContext } from './context/coordinate.context';
import { Routes, Route  } from 'react-router-dom';
import { AddAdvert } from './components/AddForm/AddAdvert';

function App() {
    const [search, setSearch] = useState('');
    const [coordinates, setCoordinates ] = useState<number[]>([]);

    return (
        <>
            <SearchContext.Provider value={{ search, setSearch }}>
                <Header />
            <CoordinatesContext.Provider value={{ coordinates, setCoordinates }}>
                <Routes>
                    <Route path="/" element={<Map />} />
                    <Route path="/add-advert" element={<AddAdvert />} />
                </Routes>
            </CoordinatesContext.Provider>
            </SearchContext.Provider>
        </>
    );
}

export default App;
